<template>
  <div>
    <!--首页弹框-->
    <Modal class="indexPopup" :value.sync="indexVisible" :closable="false" :scrollable="true" :footer-hide="true"
      :styles="{ top: '150px' }">
      <p class="item-close" @click.stop="close()">
        <img src="static/img/popup/close_30.png" alt="" />
      </p>
      <div style="flex-wrap: nowrap;padding-left: 30%;" v-if="isPercentImg!= 0 || isPercentImg != ''">
        <span style="color: white;font-weight: 600;font-size: 20px;white-space: nowrap;">
          {{isPercentImg}}
        </span>
        <span style="color: white;font-weight: 500;font-size: 17px;white-space: nowrap;">
          {{isPercentText}}
        </span>
      </div>
      <div @click="goThat" class="item-img">
        <img :src="popupData.img_url ||
          '../../../static/img/goodsList/goods_default_img.jpg'
          " :onerror="defaultGoodsImg" alt="图片破损" />
      </div>
    </Modal>
    <!--首页弹框-->
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapGetters } from "vuex";
import { getIndexBulletFrame } from "@/api/index";
import { behaviorUserPageAccess, } from '@/api/apiPot.js'
import { lineLocal } from '@/api/apiPot.js'
export default {
  name: "IndexPopup",
  props: {
    indexVisible: {
      type: Boolean,
      default: false
    },
    popupData: {
      type: Object,
      default: {
        ad_url: '',
        img_url: '',
      }
    }
  },
  data() {
    return {
      defaultGoodsImg:
        'this.src="' +
        require("../../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      imgName: '',
			isPercentImg: 0,
			isPercentText:'', //弹窗提示
    };
  },
  mounted() {
    this.indexImg();
  },
  methods: {
    indexImg() {
      /**首页弹出框图片 */
      let _this = this;
      getIndexBulletFrame({ type: 1 })
        .then(res => {
          this.isPercentText = ''
          this.isPercentImg = res.data.BulletFrame.auto_close_time
          console.log("获取首页弹框图", res);
          if(res.data.BulletFrame.auto_close_time != 0){
          	this.isPercentText = '秒后自动关闭'
          	const timer = setInterval(() => {
          	    this.isPercentImg--;
          	    if(this.isPercentImg === 0){
          	        clearInterval(timer);
          	        this.isPercentImg = 0;
          	        this.$emit("update:indexVisible", false); // 隐藏弹窗
          	    }
          	}, 1100);
          }
          // lineLocal({ source_type: 7, source_info: '弹窗' })
          this.imgName = res.data.BulletFrame.ad_name
          this.$emit('update:popupData', res.data.BulletFrame); // 发送事件更新父组件的 popupData
          lineLocal({ source_type: 7, source_info: this.imgName })
          // this.popupData = res.data.BulletFrame;
        })
        .catch(err => {
          console.log(err);
        });
    },
    goThat() {
      // this.$router.push({ path: this.popupData.ad_url });
      behaviorUserPageAccess({ page_index: '列表' })
      window.open(
        this.$router.resolve({ path: this.popupData.ad_url }).href,
        "_blank"
      );
      this.close()
    },
    close() {
      this.$emit("update:indexVisible", false);
      this.$store.dispatch("app/setIndexPopState", 1);
    }
  },
  store
};
</script>

<style lang="less" scoped>
.indexPopup {
  text-align: center;

  .item-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: -31%;
    top: -25px;
    cursor: pointer;
    z-index: 1000;
    pointer-events: auto;
  }

  .item-img {
    width: 676px;
    height: 600px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.indexPopup /deep/ ivu-modal {}

.indexPopup /deep/ .ivu-modal-content {
  position: relative;
  height: auto;
  background-color: rgb(0 0 0 / 0) !important;
  box-shadow: 0 0 0 rgb(0 0 0 / 0) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/IndexPopup.vue